import type { Bucket } from '@/entities/bucket';
import request from '@/shared/api/request';

export const getBucket = (name: string): Promise<{ bucket: Bucket }> =>
  request({
    url: `/buckets/${name}`,
  });
